module.exports = __webpack_public_path__ + "img/05@2x.9bc55621.png";